import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { sectionDividerSx } from '../styles';

const SectionDivider = ({ title, subtitle }) => (
    <Box sx={sectionDividerSx}>
      <Typography component="span">{title}</Typography>
      {subtitle && (
        <Typography component="small">{subtitle}</Typography>
      )}
    </Box>
  );

SectionDivider.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default SectionDivider;
